import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'hideMenuFilter'
})
export class FilterItemMenuHidePipe implements PipeTransform {
  transform(items: any): any {
    return items.filter(item => item.hide !== true);
  }
}
